import * as React from 'react';
import { createContext, useContext } from 'react';

import { useExperiment } from '@coursera-web/statsig';

const EXPERIMENT_NAME = 'enable_takeover_pilot';
const ALLOCATION_PARAM_NAME = 'allocation';

const TakeoverPilotExperimentContext = createContext(false);

export const useTakeoverPilotExperiment = () => useContext(TakeoverPilotExperimentContext);

function TakeoverPilotExperimentProvider({ children }: React.PropsWithChildren) {
  const experiment = useExperiment(EXPERIMENT_NAME);
  const isInTreatment = experiment.get(ALLOCATION_PARAM_NAME, false) === true;

  return (
    <TakeoverPilotExperimentContext.Provider value={isInTreatment}>{children}</TakeoverPilotExperimentContext.Provider>
  );
}

export default TakeoverPilotExperimentProvider;
